import { REVIEW_SECTION_ANCHOR, ExtraBadgesCharId, QdsSize } from '@pes-ui/utils';
import { h } from '@stencil/core';
import cn from 'classnames';
import { isWebkitLineClampSupports } from '../../../globals/style.utils';
import { PesProductLink } from '../pes-product-link/pes-product-link';
import { IconPlus } from '../../UI/icon-plus/icon-plus';
import { isMobile } from '../../../globals/utils';
import { ProductCardAdditionalContent } from './product-card-additional-content';
import { PesTag } from '../../reusable/pes-tag';
export class ProductCardMainInfo {
  constructor() {
    this.miaLogo = null;
    this.logosUrls = null;
    this.enumber = undefined;
    this.pdpUrl = undefined;
    this.description = undefined;
    this.bundledProduct = false;
    this.bundleQty = undefined;
    this.bundleUrl = undefined;
    this.bundleDescription = undefined;
    this.bundleDetailsLabel = undefined;
    this.bundleItemsLabel = undefined;
    this.commercialReference = undefined;
    this.bundleCommercialReferenceBundle = undefined;
    this.layout = 'grid';
    this.repositoryId = undefined;
    this.bundleRepositoryId = undefined;
    this.enableAppRouting = undefined;
    this.hostWithoutLocaleCodes = undefined;
    this.greenPremiumLogo = undefined;
    this.pdsLogo = undefined;
    this.commercialInfo = undefined;
    this.isMobile = false;
    this.bazaarVoiceEnabled = false;
    this.productsRatings = undefined;
    this.badge = undefined;
    this.isExternalConsumer = false;
    this.viewDetailUrl = undefined;
    this.handleProductClick = undefined;
    this.extraBadges = undefined;
    this.circularAvailability = undefined;
    this.tags = undefined;
    this.isMobileView = isMobile();
    this.productTags = [];
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getLogoUrl(name) {
    if (!this[name])
      return null;
    if (this[name].absoluteUrl) {
      return this[name].absoluteUrl;
    }
    return this.hostWithoutLocaleCodes + this[name].url;
  }
  urlWithAnchorToReview(href) {
    const url = new URL(href);
    url.hash = REVIEW_SECTION_ANCHOR;
    return url.href;
  }
  renderLogos() {
    if (!this.greenPremiumLogo && !this.pdsLogo && !this.miaLogo) {
      return null;
    }
    return (h("div", { class: "logo" }, this.miaLogo && (h("img", { class: "made-in-america", src: this.logosUrls.miaLogoUrl, alt: this.miaLogo.alt, width: "40", height: "40" })), this.pdsLogo && (h("img", { class: "brand", src: this.logosUrls.pdsLogoUrl, alt: this.pdsLogo.alt, width: "60" })), this.greenPremiumLogo && (h("img", { class: "green-premium", src: this.logosUrls.greenPremiumLogoUrl, alt: this.greenPremiumLogo.alt, width: "54" }))));
  }
  renderDescription() {
    return (h(PesProductLink, { className: cn('description', this.isMobile && 'description-mobile'), url: this.isExternalConsumer ? this.viewDetailUrl : this.pdpUrl, id: this.repositoryId, enableAppRouting: this.enableAppRouting }, h("a", { href: this.pdpUrl, onClick: this.handleProductClick, class: "description-link", title: this.description && this.description.replace(/&nbsp;/g, String.fromCharCode(160)) }, h("h3", { class: `description-link__content ${this.layout}`, innerHTML: isWebkitLineClampSupports() ? this.description : '', "data-da-element-id": "p_tile_sub" }, !isWebkitLineClampSupports() && (h("pes-ellipsis", { maxHeight: "80px", modifier: this.layout, content: this.description }))))));
  }
  renderCommercialReference(reference, url, repositoryId) {
    if (this.isMobileView && this.enumber)
      return null;
    return (h(PesProductLink, { className: this.bundledProduct ? 'commercial-reference__bundle' : 'commercial-reference', url: this.isExternalConsumer ? this.viewDetailUrl : url, id: repositoryId, enableAppRouting: this.enableAppRouting }, h("a", { href: this.isExternalConsumer ? this.viewDetailUrl : url, class: "commercial-reference-link", "data-da-element-id": "p_tile_t", title: reference, onClick: this.handleProductClick }, reference)));
  }
  renderBundleDescriptionItem(description, url, isMain) {
    const productTitle = description && description.replace(/&nbsp;/g, String.fromCharCode(160));
    const id = isMain ? 'p_tile_sub_main' : 'p_tile_sub_bundle';
    const linkClassName = isMain ? 'main-product-link' : 'bundle-product-link';
    return (h("a", { href: url, class: linkClassName, "data-da-element-id": id, title: productTitle, innerHTML: isWebkitLineClampSupports() ? description : '' }, !isWebkitLineClampSupports() && (h("pes-ellipsis", { maxHeight: "50px", modifier: this.layout, content: description }))));
  }
  renderBundleDescription() {
    return (h(PesProductLink, { className: cn('bundle-description', this.isMobile && 'bundle-description-mobile'), url: this.pdpUrl, id: this.repositoryId, enableAppRouting: this.enableAppRouting }, h("div", { class: "count-ellips" }, "x1"), this.renderBundleDescriptionItem(this.description, this.pdpUrl, true), IconPlus(), h("div", { class: "count-ellips" }, "x", this.bundleQty), this.renderBundleDescriptionItem(this.bundleDescription, this.bundleUrl)));
  }
  renderBundledTooltip() {
    var _a, _b;
    const commonQuantity = 1 + this.bundleQty;
    return (h("pdp-icon-tooltip", { class: "toggle-icon-info m-hidden", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top", text: this.bundleDetailsLabel || 'UPS Solution details' }, h("div", { class: "tooltip-content" }, h("div", { class: "tooltip-title" }, h("span", null, `${this.bundleItemsLabel || 'Items:'} ${commonQuantity}`)), h("div", { class: "tooltip-main-product" }, h("div", { class: "count-ellips" }, "x1"), this.renderBundleDescriptionItem(this.description, this.pdpUrl, true)), h("div", { class: "tooltip-bundle-rating" }, this.renderCommercialReference(this.commercialReference, this.pdpUrl, this.repositoryId), h("pes-star-rating", { bazaarVoiceEnabled: this.bazaarVoiceEnabled, ratingData: (_a = this.productsRatings) === null || _a === void 0 ? void 0 : _a[this.repositoryId], url: this.urlWithAnchorToReview(this.pdpUrl) })), h("div", { class: "tooltip-bundle-product" }, h("div", { class: "count-ellips" }, "x", this.bundleQty), this.renderBundleDescriptionItem(this.bundleDescription, this.bundleUrl)), h("div", { class: "tooltip-bundle-rating" }, this.renderCommercialReference(this.bundleCommercialReferenceBundle, this.bundleUrl, this.bundleRepositoryId), h("pes-star-rating", { bazaarVoiceEnabled: this.bazaarVoiceEnabled, ratingData: (_b = this.productsRatings) === null || _b === void 0 ? void 0 : _b[this.bundleRepositoryId], url: this.urlWithAnchorToReview(this.bundleUrl) })))));
  }
  filterProductTags(tags) {
    if (!tags)
      return null;
    this.productTags = Object.entries(this.tags).filter(([_, value]) => { var _a; return ((_a = value.label) === null || _a === void 0 ? void 0 : _a.trim()) !== ''; });
  }
  componentWillLoad() {
    var _a, _b;
    this.miaLogo = (_b = (_a = this.extraBadges) === null || _a === void 0 ? void 0 : _a.find(({ charId }) => charId === ExtraBadgesCharId.ATS_MADE_IN_AMERICA)) === null || _b === void 0 ? void 0 : _b.url;
    this.filterProductTags(this.tags);
    if (!this.greenPremiumLogo && !this.pdsLogo && !this.miaLogo) {
      return null;
    }
    this.logosUrls = {
      miaLogoUrl: this.getLogoUrl('miaLogo'),
      greenPremiumLogoUrl: this.getLogoUrl('greenPremiumLogo'),
      pdsLogoUrl: this.getLogoUrl('pdsLogo'),
    };
  }
  render() {
    return (h("div", { class: `main-info ${this.layout}` }, !this.tags && !this.isMobileView && (h(ProductCardAdditionalContent, { badge: this.badge, commercialInfo: this.commercialInfo, circularAvailability: this.circularAvailability })), this.isMobileView && this.circularAvailability && (h("div", { class: "main-info__qds-tag" }, h("qds-tag", { text: this.circularAvailability, status: "success", size: QdsSize.SMALL }))), this.productTags.length > 0
      && (h("div", { class: "pes-tags" }, this.productTags.map(([key, value]) => (h(PesTag, { key: key, id: key, value: value, size: QdsSize.SMALL }))))), h("div", { class: "main-info__product-links" }, this.renderLogos(), this.enumber && (h(PesProductLink, { className: "enumber", url: this.pdpUrl, id: this.repositoryId, enableAppRouting: this.enableAppRouting }, h("a", { href: this.pdpUrl, class: "enumber-link" }, h("span", null, this.enumber.code, ":"), this.enumber.value))), !this.bundledProduct
      && this.renderCommercialReference(this.commercialReference, this.pdpUrl, this.repositoryId)), this.bundledProduct ? this.renderBundleDescription() : this.renderDescription(), this.bundledProduct && this.renderBundledTooltip()));
  }
  static get is() { return "product-card-main-info"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["main-info.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["main-info.css"]
    };
  }
  static get properties() {
    return {
      "enumber": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ code: string; value: string }",
          "resolved": "{ code: string; value: string; }",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Enumber object contains code label and value.\nUsed in some countries."
        }
      },
      "pdpUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Product page url used in links."
        },
        "attribute": "pdp-url",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Product description."
        },
        "attribute": "description",
        "reflect": false
      },
      "bundledProduct": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Show if product is bundle product"
        },
        "attribute": "bundled-product",
        "reflect": false,
        "defaultValue": "false"
      },
      "bundleQty": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Bundle product quantity."
        },
        "attribute": "bundle-qty",
        "reflect": false
      },
      "bundleUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Bundle product URL."
        },
        "attribute": "bundle-url",
        "reflect": false
      },
      "bundleDescription": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Bundle product description."
        },
        "attribute": "bundle-description",
        "reflect": false
      },
      "bundleDetailsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Bundle product detail label."
        },
        "attribute": "bundle-details-label",
        "reflect": false
      },
      "bundleItemsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Bundle product items label."
        },
        "attribute": "bundle-items-label",
        "reflect": false
      },
      "commercialReference": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Commercial reference to show as product name."
        },
        "attribute": "commercial-reference",
        "reflect": false
      },
      "bundleCommercialReferenceBundle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Commercial reference to show as bundle name."
        },
        "attribute": "bundle-commercial-reference-bundle",
        "reflect": false
      },
      "layout": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'grid' | 'list'",
          "resolved": "\"grid\" | \"list\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Card layout."
        },
        "attribute": "layout",
        "reflect": false,
        "defaultValue": "'grid'"
      },
      "repositoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Product id."
        },
        "attribute": "repository-id",
        "reflect": false
      },
      "bundleRepositoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Bundle id."
        },
        "attribute": "bundle-repository-id",
        "reflect": false
      },
      "enableAppRouting": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "PBS application routing functionality configuration."
        },
        "attribute": "enable-app-routing",
        "reflect": false
      },
      "hostWithoutLocaleCodes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Host url without lang and country codes for green-premium and brand images"
        },
        "attribute": "host-without-locale-codes",
        "reflect": false
      },
      "greenPremiumLogo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Logo",
          "resolved": "{ url: string; absoluteUrl: string; alt: string; }",
          "references": {
            "Logo": {
              "location": "import",
              "path": "../product-card"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Green-premium logo for product card"
        }
      },
      "pdsLogo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Logo",
          "resolved": "{ url: string; absoluteUrl: string; alt: string; }",
          "references": {
            "Logo": {
              "location": "import",
              "path": "../product-card"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "PDS logo for product card (e.g. Square D)"
        }
      },
      "commercialInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Pick<ProductInfoApi.ProductAdditionalInfo, 'commercialMessage' | 'commercialColor' | 'commercialTextColor'>",
          "resolved": "{ commercialMessage: string; commercialColor: string; commercialTextColor: string; }",
          "references": {
            "Pick": {
              "location": "global"
            },
            "ProductInfoApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Commercial info for product card"
        }
      },
      "isMobile": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Mobile view flag"
        },
        "attribute": "is-mobile",
        "reflect": false,
        "defaultValue": "false"
      },
      "bazaarVoiceEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Enable or disable bazaarVoice"
        },
        "attribute": "bazaar-voice-enabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "productsRatings": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductsRatings",
          "resolved": "{ [x: string]: TRatingData; }",
          "references": {
            "TProductsRatings": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Bundled products ratings."
        }
      },
      "badge": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBadge",
          "resolved": "{ label: string; type: TBadgeType; }",
          "references": {
            "TBadge": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Badges for product card (new, best-seller, best-value, best-performance, featured, etc.)"
        }
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false,
        "defaultValue": "false"
      },
      "viewDetailUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines customized url(s) of hyperlink for external-user"
        },
        "attribute": "view-detail-url",
        "reflect": false
      },
      "handleProductClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(event: MouseEvent)=>void",
          "resolved": "(event: MouseEvent) => void",
          "references": {
            "MouseEvent": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Callback for saving breadcrumbs in indexDB"
        }
      },
      "extraBadges": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsApi.ExtraBadges[]",
          "resolved": "ExtraBadges[]",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Extra badges for product card - currently only Made in America (MIA) Logo is available"
        }
      },
      "circularAvailability": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Circular availability label for product card"
        },
        "attribute": "circular-availability",
        "reflect": false
      },
      "tags": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "PesTagsData",
          "resolved": "{ [key: string]: { label: string; }; }",
          "references": {
            "PesTagsData": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isMobileView": {},
      "productTags": {}
    };
  }
  static get elementRef() { return "el"; }
}
